import { render, staticRenderFns } from "./GenderFilters.vue?vue&type=template&id=068a3152&"
import script from "./GenderFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GenderFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068a3152')) {
      api.createRecord('068a3152', component.options)
    } else {
      api.reload('068a3152', component.options)
    }
    module.hot.accept("./GenderFilters.vue?vue&type=template&id=068a3152&", function () {
      api.rerender('068a3152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/GenderFilters/GenderFilters.vue"
export default component.exports